var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGerminate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6175 7.2225C11.4975 5.4075 10.845 3.63 9.63749 2.1525C9.32999 1.7775 8.76748 1.7775 8.45998 2.1525C7.22248 3.6375 6.53249 5.415 6.38249 7.2225C7.34249 7.7325 8.22748 8.3925 8.99998 9.195C9.77248 8.4 10.6575 7.74 11.6175 7.2225ZM6.74249 9.21C6.63749 9.135 6.51749 9.0675 6.40498 8.9925C6.51749 9.075 6.63749 9.135 6.74249 9.21ZM11.5575 9.0225C11.46 9.09 11.355 9.1425 11.2575 9.2175C11.355 9.1425 11.46 9.09 11.5575 9.0225ZM8.99998 11.5875C7.53748 9.36 5.14499 7.815 2.37749 7.545C1.89749 7.5 1.49998 7.8975 1.54498 8.3775C1.88248 11.9775 4.28249 14.9625 7.52998 16.125C8.00249 16.2975 8.49748 16.425 9.00748 16.5075C9.51749 16.4175 10.005 16.29 10.485 16.125C13.7325 14.9625 16.1325 11.985 16.47 8.3775C16.515 7.8975 16.11 7.5 15.6375 7.545C12.855 7.815 10.4625 9.36 8.99998 11.5875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerminate);
export default __webpack_public_path__ + "static/media/Germinate.b27c68be0d889a1b8b23d4226937b6d0.svg";
export { ForwardRef as ReactComponent };